/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S10_Li4_TextInputs */

const tr_onbilgi_s10_li4_text = /** @type {(inputs: Onbilgi_S10_Li4_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tenant-bazlı veri izolasyonu (her firma için ayrı şema), Cloudflare WAF, oran sınırlama (rate limiting), audit log kayıtları (KVKK Madde 12).`)
};

const en_onbilgi_s10_li4_text = /** @type {(inputs: Onbilgi_S10_Li4_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tenant based data isolation (a separate schema for each company), Cloudflare WAF, rate limiting, audit log records (KVKK Madde 12).`)
};

const de_onbilgi_s10_li4_text = /** @type {(inputs: Onbilgi_S10_Li4_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mandantenbezogene Datenisolierung (ein eigenes Schema je Firma), Cloudflare WAF, Ratenbegrenzung (rate limiting), Audit-Log-Aufzeichnungen (KVKK Madde 12).`)
};

const ru_onbilgi_s10_li4_text = /** @type {(inputs: Onbilgi_S10_Li4_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изоляция данных по арендаторам (отдельная схема для каждой компании), Cloudflare WAF, ограничение частоты запросов (rate limiting), записи журнала аудита (KVKK Madde 12).`)
};

/**
* | output |
* | --- |
* | "Tenant based data isolation (a separate schema for each company), Cloudflare WAF, rate limiting, audit log records (KVKK Madde 12)." |
*
* @param {Onbilgi_S10_Li4_TextInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s10_li4_text = /** @type {((inputs?: Onbilgi_S10_Li4_TextInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S10_Li4_TextInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s10_li4_text(inputs)
	if (locale === "de") return de_onbilgi_s10_li4_text(inputs)
	if (locale === "ru") return ru_onbilgi_s10_li4_text(inputs)
	return tr_onbilgi_s10_li4_text(inputs)
});